import { Container } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { UserRequestPanel } from '../components/AdminPage/UserRequestPanel';
import UserStatsPage from '../components/AdminPage/UserStats';
import { useAuth } from '../components/Providers/AuthProvider';
import { useFeatures } from '../components/Providers/FeatureProvider';
import { myFolder } from '../redux/consts';
import { StyledTab, StyledTabs } from '../theme/CustomComponents';
import { AdminTab } from '../Types/enums';

const AdminPage = (): JSX.Element => {
  const { subroute } = useParams();
  const features = useFeatures();
  const { isAdmin } = useAuth();
  const navigate = useNavigate();

  const [currentTab, setCurrentTab] = useState<AdminTab>(AdminTab.USER_STATS);

  useEffect(() => {
    if (!(isAdmin || features.stats_page_access)) {
      navigate(`/folder/${myFolder.id}`);
    }
  }, [navigate, isAdmin, features.stats_page_access]);

  useEffect(() => {
    if (subroute === 'user-requests' && isAdmin) {
      setCurrentTab(AdminTab.USER_REQUEST_PANEL);
    }
  }, [subroute, isAdmin]);

  const changeTab = (_event: React.SyntheticEvent, newValue: AdminTab) => {
    setCurrentTab(newValue);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflowY: 'auto',
        height: '100%',
        width: '100%',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <StyledTabs value={currentTab} onChange={changeTab} centered variant="fullWidth">
          {(isAdmin || features.stats_page_access) && (
            <StyledTab label="User Stats" value={AdminTab.USER_STATS} />
          )}
          {isAdmin && <StyledTab label="User Request Panel" value={AdminTab.USER_REQUEST_PANEL} />}
        </StyledTabs>
      </div>
      <Container
        maxWidth="md"
        sx={{
          position: 'relative',
          bgcolor: 'white',
          height: '100%',
          margin: '50px',
          marginTop: '0',
        }}
      >
        {currentTab === AdminTab.USER_STATS && <UserStatsPage />}
        {currentTab === AdminTab.USER_REQUEST_PANEL && <UserRequestPanel />}
      </Container>
    </div>
  );
};

export default AdminPage;
